import o from "./browser/index.js";
import * as t from "./common/utils.js";
const m = {
  ...t,
  ...o
};
export {
  m as default
};
